var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"public-stepper"},[_c('div',{staticClass:"progress-line",style:(_vm.lineStyles)}),_vm._l((_vm.steps),function(step){return _c('span',{key:step,staticClass:"step",class:{
			current: step === _vm.currentStep,
			done: _vm.currentStep > step
		}},[(_vm.currentStep > step)?_c('v-icon',{attrs:{"color":"--white","small":"","name":"check"}}):_vm._e()],1)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }